import { FC } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import MuiTheme from "./theme";
import { WagmiConfig, createClient } from "wagmi";
import { getDefaultProvider } from "ethers";
import AppLayout from "./router/Layout";

const client = createClient({
  autoConnect: true,
  provider: getDefaultProvider(),
});

const App: FC = () => {
  return (
    <div className="App">
      <Provider store={store}>
        <MuiTheme>
          <BrowserRouter>
            <WagmiConfig client={client}>
              <AppLayout />
            </WagmiConfig>
          </BrowserRouter>
        </MuiTheme>
      </Provider>
    </div>
  );
};

export default App;
